export enum View {
  Minimize = 'minimize',
  Preview = 'preview',
  Open = 'open',
  FullScreen = 'fullscreen',
}
